/**
 * When REACT_APP_ALTERNATE_SIGN_UP_URL is non-empty, alternate soona
 * redirect UI is shown (auth, campaign summary banner, etc.).
 */
export const alternateSignUpUrl = (process.env.REACT_APP_ALTERNATE_SIGN_UP_URL || '').trim();

export const alternateSignUpButtonLabel =
  (process.env.REACT_APP_ALTERNATE_SIGN_UP_BUTTON_LABEL || '').trim() || 'Start project on soona';

export const alternateSignUpVideo = (process.env.REACT_APP_ALTERNATE_SIGN_UP_VIDEO || '').trim();

export const alternateSignUpCampaignUrl = `${alternateSignUpUrl}#/account/<accountId>/ugc/brief/new/content`;

export const isAlternateSignUpEnabled = alternateSignUpUrl.length > 0;

/** New-campaign dialog is shown once Trend stops accepting campaigns (Oct 1, 2026). */
const ALTERNATE_CAMPAIGN_DIALOG_START = Date.UTC(2026, 9, 1);

export const isAlternateCampaignDialogEnabled =
  isAlternateSignUpEnabled && Date.now() >= ALTERNATE_CAMPAIGN_DIALOG_START;
